
import React from 'react';

export default class DeleteButton extends React.Component {
    render() {
        return (
            <div className="deleteButton" onClick={this.props.onClick}>
                <div className="line one"></div>
                <div className="line two"></div>
            </div>
        );
    }
}